import firebase from 'firebase';


const firebaseConfig = {
  apiKey: "AIzaSyD2E15J005mUGe5EXFVN6HVOqI1jv1RjWY",
  authDomain: "noobg-319314.firebaseapp.com",
  projectId: "noobg-319314",
  storageBucket: "noobg-319314.appspot.com",
  messagingSenderId: "1010594964171",
  appId: "1:1010594964171:web:a43a6552ebb7a74731314e",
  measurementId: "G-CB77RETGMT"
};
 
  const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };